import { render, staticRenderFns } from "./colourPicker.vue?vue&type=template&id=4ae256f8&"
import script from "./colourPicker.vue?vue&type=script&lang=ts&"
export * from "./colourPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Source\\WebMap\\Monthly\\Sites\\WebMap\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ae256f8')) {
      api.createRecord('4ae256f8', component.options)
    } else {
      api.reload('4ae256f8', component.options)
    }
    module.hot.accept("./colourPicker.vue?vue&type=template&id=4ae256f8&", function () {
      api.rerender('4ae256f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Script/Components/ManagerView/Style/colourPicker.vue"
export default component.exports